import { type EventResizeConfig } from '@bryntum/schedulerpro'
import { tooltipTemplate } from './tooltipTemplate'
import { validatorFn } from './validatorFn'

export const eventResize: Partial<EventResizeConfig> = {
  validatorFn,
  tooltipTemplate,
}
